/** API route map: URLS.Controller.Applicant */
export const Applicant = {
      Name: 'Applicant/',
      GetAll: 'get-all',
      Delete: 'delete',
      ConvertToCandidate: 'convert-candidate',
      ConvertToCandidateBank: 'convert-candidate-bank',
      ApplicantDetails: 'get-applicant-details',
      GetEmailTemplate: 'get-candidate-email',
      GetMessage: 'get-candidate-message',
      GetApplicantSkills: 'get-all-skills',
};
